<script>
  import { createEventDispatcher } from 'svelte';

  export let categories;

  let activeCategory = { id: null, name: null };

  const dispatch = createEventDispatcher();

	function handleClick(id, name) {
    if (activeCategory.id === id) {
      dispatch('clear');
      activeCategory = { id: null, name: null };
    } else {
      dispatch('change', { categoryId: id });
      activeCategory = { id, name };
    }
	}
</script>
<div class="ui vertical fluid menu">
  <div class="item">
    <h3 class="header">Categorías</h3>
  </div>
	{#each categories as { id, slug, name }}
    <a href={slug} class="item" class:active={activeCategory.id === id} on:click|preventDefault={() => handleClick(id, name)}>
      {name}
    </a>
	{:else}
		<div class="item">Cargando...</div>
	{/each}
</div>
